import React from 'react';
import { get, map } from 'lodash';

import type { BannerItemsByZoneId } from '../../../types';
import MobileTopMatchItem from '../MobileTopMatchItem';
import useMobileTopMatch from './useMobileTopMatch';

interface Props {
    sport: string;
    zones: BannerItemsByZoneId;
    missingSportEventIds: string[];
}

const MobileTopMatch: React.FC<Props> = ({
    missingSportEventIds,
    sport,
    zones,
}) => {
    useMobileTopMatch({ missingSportEventIds });

    return (
        <React.Fragment>
            {map(zones, (sports, zoneId) => {
                const sportEventIds = get(sports, sport, undefined);

                if (!sportEventIds) return null;

                return (
                    <MobileTopMatchItem
                        key={zoneId}
                        zoneId={zoneId}
                        sportEventIds={sportEventIds}
                    />
                );
            })}
        </React.Fragment>
    );
};

export default React.memo(MobileTopMatch);
